import { createApp } from 'vue'
import App from './App.vue'
import breadcrumbs from 'vue-3-breadcrumbs'
import './registerServiceWorker'
import router from './router'
import store from './store'
require('./assets/style/main.css')
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import {languages} from "@/i18n"
import i18n from "@/i18n";
import {createI18n, useI18n} from 'vue-i18n'
// const messages = Object.assign(languages)
// const i18n = new createI18n({
//   legacy: false,
//   locale: defaultLocale,
//   fallbackLocale: 'ru',
//   messages,
// })

createApp(App, {
  setup() {
    const {t} = useI18n()
    return {t}
  }
})
  .use(i18n)
  .use(store)
  .use(router)
  .use(breadcrumbs)
  .mount('#app')

